$(document).ready(function(){

	var shopPageSlider = new Swiper(".shop-page-top-slider", {
		slidesPerView: 1.2,
		loop: false,
		center: false,
		spaceBetween: 16,
		centeredSlides: false,
		freeMode: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			992: {
				slidesPerView: 3,
				spaceBetween: 24,
				pagination: {
					enabled: false,
				}
			},	
		}
	});

	// Accordion on Sidebar
	$('.shop-page-main-accordion-item').on('click', 'h4', function() {
		$(this).parent().siblings().removeClass('shop-page-main-accordion-item-active');
		$(this).parent().toggleClass('shop-page-main-accordion-item-active');
	});

	$('.sort-menu-desktop-title').on('click', function() {
		$(this).parent().toggleClass('sort-menu-desktop-active');
	});

	// Mobile sticky Filter
	$('.shop-page-main-mobile-filter').on('click', function() {
		$('.shop-page-main-col-left').toggleClass('shop-page-main-col-left-active');
		if ($('.shop-page-main-col-left-active')[0]) {
			$('html, body').addClass('body-overflow');				
		} else {
			$('html, body').removeClass('body-overflow');
		}
	});

	$('.filter-header-mobile-close').on('click', function() {
		$('.shop-page-main-col-left').removeClass('shop-page-main-col-left-active')
		$('html, body').removeClass('body-overflow');
	});

	if ($(window).width() < 992) {
		$(window).scroll(function() {
			var divToCheckScroll = $(".shop-page-main-col-left");
			var top_of_element = divToCheckScroll.offset().top;
			var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
			if (bottom_of_screen > top_of_element) {
				// the element is visible
				$('.shop-page-main-mobile-filter').addClass('shop-page-main-mobile-filter-scrolled');
			} else {
				// the element is not visible
				$('.shop-page-main-mobile-filter').removeClass('shop-page-main-mobile-filter-scrolled');
			}
		});
	}

});



